import { RatingConfig } from "../models";
import rawConfig from "virtual:config";
import { RatingConfigSchema } from "../../shared/config.schema";

const validated = RatingConfigSchema.parse(rawConfig);

export const APP_CONFIG: RatingConfig = {
  ...validated,
  datasetColors: validated.datasetColors ?? ["#4a90e2"],
};
